import React, { useRef,useState } from 'react';
import './index.less';
import { NavLink, } from 'react-router-dom';
import logos from '@/assets/logo-bottom.png';

const  BottomPage =()=> {

   const navList = [
      { path: '/product', name: 'Computing Power Rental' },
      { path: '/decentralized/Efficient', name: 'Blockchain Infrastructure' },
      { path: '/decentralized/Empowering', name: 'Decentralized Applications' },
      { path: '/decentralized/Breaking', name: 'Cross-Chain Solutions' },
    ]

    const NavClick = (path,event)=>{
      console.log(path)
      if(!path){
        event.preventDefault()
      }
    }

    return (  
      <div className='bottom_page'>
         <div className="top_log ">
            <div className="logos"><img src={logos} alt="" /></div>
            <p>AETHER</p>
         </div>
         <div className="bottom_bar">
                  <div className='nav_list'>
                  {
                     navList.map((val, index) => {
                     return <div className='nav_item'>
                        <div className="nav_item_content">
                           <NavLink onClick={(e)=>NavClick(val.path,e)} className={({ isActive }) => `${isActive ? "active" : ""}`} to={val.path}>
                              {val.name}
                           </NavLink>
                        </div>
                     </div>
                     })
                  }
               </div>
         </div>
      </div>  
    );  
}
  
export default  BottomPage;